import '../styles/SpecialSection.css';
import pic from "../assets/DSC_1313.jpg";
import pic1 from "../assets/school.jpg";

const SpecialSection = () => {
  return (
    <div className='sgb-school-main'>
    <div className="sgb-special-section-wrapper">
     <div className='sgb-data'>
      
        <p>IDEAL EDUCATION POINT SETH G.L. BIHANI S.D. Senior Secondary School is a 
          reputed co-educational RBSE institution in Sri Ganganagar, known for academic 
          excellence and value-based education. Situated on a vast, pollution-free campus, 
          the school provides a peaceful and inspiring environment for learning.</p>

        <p>We offer strong academic streams in Commerce, Science, Mathematics, and Agriculture, 
          supported by experienced faculty and modern teaching practices. With the integration
           of computer-aided learning and innovative educational brmethods, we ensure that students 
           stay aligned with 21st-century advancements.</p>  

        <p>Our focus goes beyond textbooks — we nurture curiosity, discipline, confidence, and leadership 
          qualities. At our school, education is designed to spark young minds, encourage exploration, 
          and empower students to achieve their dreams while becoming responsible citizens of tomorrow.</p>

     </div>
    </div>
    </div>
  );
};

export default SpecialSection;